import {create} from 'zustand';

import {DEFAULT_UNITS_LIST} from './constants';
import {UnitsListStore} from './types';

const useUnitsListStore = create<UnitsListStore>(set => ({
	unitsList: DEFAULT_UNITS_LIST,
	setUnitsList: value =>
		set(state => ({
			unitsList: typeof value === 'function' ? value(state.unitsList) : value,
		})),
	resetUnitsList: () => set({unitsList: DEFAULT_UNITS_LIST}),
}));

export {useUnitsListStore};
